import { render, staticRenderFns } from "./client-board-filter.vue?vue&type=template&id=6177bf04"
import script from "./client-board-filter.vue?vue&type=script&lang=js"
export * from "./client-board-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports